import React, { Component } from 'react';
import { object, string, bool } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import Breadcrumb from '@blueberry/components/Breadcrumb';

import { VIDEO } from '@blueberry/constants/postType';

import VideoPostContent from './components/VideoPostContent';
import ArticlePostContent from './components/ArticlePostContent';

import { getLocaleCode } from '@blueberry/redux/locale';
import { getIsInapp } from '@blueberry/redux/location';

import breadcrumbTheme from './breadcrumbTheme.scss';

const mapStateToProps = state => ({
  locale: getLocaleCode(state),
  isInapp: getIsInapp(state),
});

class PostContent extends Component {
  static propTypes = {
    isInapp: bool.isRequired,
    locale: string.isRequired,
    post: object.isRequired,
  };

  renderBreadcrumb() {
    const {
      post: {
        curriculumName,
        subjectId,
        subjectName,
        subtopicId,
        subtopicName,
      },
      locale,
    } = this.props;
    const breadcrumbItems = [];

    if (!!curriculumName) {
      breadcrumbItems.push({
        name: curriculumName,
      });
    }

    if (!!subjectName) {
      breadcrumbItems.push({
        link: `/${locale}/subject/${subjectName}-${subjectId}`,
        name: subjectName,
      });
    }

    if (!!subtopicName) {
      breadcrumbItems.push({
        link: `/${locale}/subject/${subjectName}-${subjectId}/${subtopicName}-${subtopicId}`,
        name: subtopicName,
      });
    }

    return <Breadcrumb items={breadcrumbItems} theme={breadcrumbTheme} />;
  }

  render() {
    const { post, isInapp } = this.props;
    const breadcrumb = this.renderBreadcrumb();

    if (post.type === VIDEO) {
      return <VideoPostContent {...post} breadcrumb={breadcrumb} />;
    }

    return (
      <ArticlePostContent {...post} breadcrumb={breadcrumb} isInapp={isInapp} />
    );
  }
}

export default compose(connect(mapStateToProps))(PostContent);



// WEBPACK FOOTER //
// ./app/containers/Post/components/PostContent/PostContent.jsx